export const oAuthMethod = {
  none: 0,
  userPassword: 1,
  emailPassword: 2,
  mobilePassword: 3,
  mobileOtp: 4,
  line: 21,
  facebook: 22,
  googleAccount: 23,
};
